import { useTranslation } from '@common/hooks/translation';
import React from 'react';

import './style.scss';

const PassportVerificationInfo = ({ closePopup }) => {
  const t = useTranslation();

  return (
    <div className="popup-content popup-small">
      <h3 className="popup-title">{t('Verification')}</h3>
      <div className="popup-main-content">
        <p className="text-center">
          {t(
            'To top up your balance or place a bet, please verify your identity by inserting your ID card into the machine or contacting our staff for assistance',
          )}
          .
        </p>
      </div>
      <button
        type="button"
        onClick={closePopup}
        className="popup-confirm-button"
      >
        {t('OK')}
      </button>
    </div>
  );
};

export default PassportVerificationInfo;
